import { Alert, Button, Snackbar } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

export interface DraftSavedSnackbarProps {
  open: boolean
  publishHref: string
  onClose: () => void
}

/** Says what a save actually did: it changed the draft, and no player has seen it. */
export default function DraftSavedSnackbar({
  open,
  publishHref,
  onClose,
}: DraftSavedSnackbarProps) {
  const { formatMessage } = useIntl()

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="success"
        onClose={onClose}
        data-testid="draft-saved"
        action={
          <Button color="inherit" size="small" href={publishHref}>
            {formatMessage({ id: 'avatarStudio.draft.reviewAndPublish' })}
          </Button>
        }
      >
        {formatMessage({ id: 'avatarStudio.draft.savedAsDraft' })}
      </Alert>
    </Snackbar>
  )
}
